import { flowAsync } from '@gcc/nodash';
import createAndSaveJob from '../_createAndSaveJob';
import prefillAtc from '../_prefillAtc';
import backfillBookJobSucceeded from '../_backfillBookJobSucceeded';
import addThdJobToCart from './_addThdJobToCart';
import backfillAtcSucceeded from '../_backfillAtcSucceeded';
import navigateToCart from '../../navigateToCart';
import copyConfigurationsForProductOnly from '../_copyConfigurationsForProductOnly';

export default cartingOptions =>
  flowAsync(
    createAndSaveJob,
    prefillAtc,
    copyConfigurationsForProductOnly,
    backfillBookJobSucceeded,
    addThdJobToCart, // cart for THD
    backfillAtcSucceeded,
    navigateToCart,
  )(cartingOptions);
